'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	/*@ngInject*/
	function _class($http, $filter) {
		_classCallCheck(this, _class);

		this.$http = $http;
		this.$filter = $filter;
		this.showNotes = false;
	}

	_createClass(_class, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.inf = true;
			this.newSession = {
				instances: 0,
				duration: 60,
				color: 'blue',
				frequency: 7
			};
			this.$http.get('/api/students').then(function (response) {
				_this.students = [];
				response.data.forEach(function (student) {
					if (student.isActive) _this.students.push(student);
				});
			});
			this.$http.get('/api/tutors').then(function (response) {
				_this.tutors = response.data;
			});

			this.colors = ['blue', 'orange', 'red', 'purple', 'grey', 'green', 'yellow', 'lime'];
		}
	}, {
		key: 'returnFilter',
		value: function returnFilter(results, $query) {
			return results.filter(function (item) {
				if (item.isActive === false) {
					return false;
				}
				return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
			});
		}
	}, {
		key: 'changeDuration',
		value: function changeDuration(duration) {
			this.newSession.duration = duration;

			if (duration === 30) {
				console.log('showing notes...');
				this.showNotes = true;
			}
		}
	}, {
		key: 'submit',
		value: function submit(data, callback) {
			var _this2 = this;

			if (!this.selectedStudent || !this.selectedTutor || !data) {
				this.error = 'Incomplete form or front-end bug. Refresh browser.';
				return;
			}

			this.newSession.startTime = data.startTime;
			this.newSession.room = data.room;
			this.newSession.location = data.location;
			this.newSession.date = this.$filter('date')(data.date, 'dd/MM/yyyy');
			this.newSession.clientUID = this.selectedStudent[0]._id;
			this.newSession.tutorUID = this.selectedTutor[0]._id;

			if (this.newSession._changeover === 'present') {
				this.newSession.changeover = true;
			}

			if (this.newSession._changeover === 'one off') {
				this.newSession.overwriteChangeover = { 0: true };
			}

			if (!this.newSession.frequency) this.newSession.instances = 1;

			if (this.newSession.frequency && this.inf) this.newSession.instances = 0;


			this.$http.post('/api/lessons', this.newSession).then(function (res) {
				_this2.error = '';
				callback({ reason: 'success', data: res.data });
			}).catch(function (res) {
				console.log(res);
				_this2.error = JSON.stringify(res.data, null, '\t');
			});
		}
	}]);

	return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/calendar/modal/session.controller.js